import type { ComponentType, ReactNode } from "react";

import type { FeedbackReaction } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

import type { MarkdownMessageProps } from "../MarkdownMessage/types";

import AIResponseMessage from "./AIResponseMessage";
import CompanyMessage from "./CompanyMessage";
import { StyledMessage } from "./styles";
import type { ChatMessageVariant } from "./types";

export type ChatMessageProps = {
    messageId?: string;
    variant?: ChatMessageVariant;
    companyName?: string;
    companyIcon?: string;
    isLoading?: boolean;
    content?: string;
    reaction?: FeedbackReaction;
    messageRef?: React.RefObject<HTMLDivElement | null>;
    mdComponentProps?: Record<string, unknown>;
    markdownComponent?: ComponentType<MarkdownMessageProps>;
    loader?: ReactNode;
    withControls?: boolean;
    onFeedback?: (reaction: FeedbackReaction) => void;
    onCopy?: () => void;
};

const ChatMessage = ({
    messageId,
    content,
    variant = "human",
    isLoading,
    companyName,
    companyIcon,
    reaction,
    messageRef,
    mdComponentProps,
    markdownComponent,
    loader,
    withControls,
    onCopy,
    onFeedback,
}: ChatMessageProps) => {
    switch (variant) {
        case "company":
            return (
                <CompanyMessage
                    companyName={companyName}
                    companyIcon={companyIcon}
                />
            );
        case "ai":
            return (
                <AIResponseMessage
                    content={content}
                    reaction={reaction}
                    isLoading={isLoading}
                    messageRef={messageRef}
                    messageId={messageId}
                    mdComponentProps={mdComponentProps}
                    markdownComponent={markdownComponent}
                    loader={loader}
                    withControls={withControls}
                    onFeedback={onFeedback}
                    onCopy={onCopy}
                />
            );
        default:
            return (
                <StyledMessage
                    variant={variant}
                    ref={messageRef as React.RefObject<HTMLDivElement>}
                    data-automation="user-message"
                >
                    {content}
                </StyledMessage>
            );
    }
};

export default ChatMessage;
